import store from "../store";
import { Howl } from "howler";
import { getCurrentLanguage } from "./language";

export const newVisitorSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_visitor")?.soundFile ||
            "new-conversation-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_visitor")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        const sound = new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
        return sound;
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-conversation-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
    }
};

export const newConversationSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_conversation")?.soundFile ||
            "new-conversation-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_conversation")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("newConversationSound error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-conversation-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newConversationSound error!", ex),
        });
    }
};

export const incomingChatSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_chat")?.soundFile ||
            "new-conversation-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_chat")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("incomingChatSound error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-conversation-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newConversationSound error!", ex),
        });
    }
};

export const newMessageSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.soundFile ||
            "new-message-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        const sound = new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
        return sound;
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/new-message-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newMessageSound error!", ex),
        });
    }
};

export const newPrivateMessage = (chatType = null) => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let notificationType = "";

        switch (chatType) {
            case "thread":
                notificationType = "team_chat_dm";
                break;
            case "department":
                notificationType = "team_chat_department";
                break;
            case "groupThread":
                notificationType = "team_chat_group";
                break;
            case "team":
                notificationType = "team_chat_team";
                break;
        }

        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === notificationType)?.soundFile ||
            "pm-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === notificationType)?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("newPrivateMessage error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/pm-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newPrivateMessage error!", ex),
        });
    }
};

export const newTicketSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "ticket_sound")?.soundFile ||
            "pm-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === "ticket_sound")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend: () => console.log('newPrivateMessage Finished!'),
            onplayerror: (ex) => console.error("newTicketSound error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/pm-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newTicketSound error!", ex),
        });
    }
};

export const newMailSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.soundFile || "pm-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume = store.state.auth.user.notificationSettings.find((x) => x.type === "new_message")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            onplayerror: (ex) => console.error("newTicketSound error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/pm-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newTicketSound error!", ex),
        });
    }
};

export const newAnnouncementSound = () => {
    if (store.state.auth.user && store.state.auth.user.notificationSettings) {
        let soundFile =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_announcement")?.soundFile ||
            "pm-default";
        if (soundFile.includes("male-"))
            soundFile += !!getCurrentLanguage() && !!getCurrentLanguage().code ? getCurrentLanguage().code : "en";
        let volume =
            store.state.auth.user.notificationSettings.find((x) => x.type === "new_announcement")?.audioLevel / 100;
        volume = isNaN(volume) ? 1 : volume;
        return new Howl({
            src: [`./static/media/ogg_folder/${soundFile}.ogg`],
            autoplay: false,
            loop: false,
            volume,
            //onend: () => console.log('newPrivateMessage Finished!'),
            onplayerror: (ex) => console.error("new_announcement error!", ex),
        });
    } else {
        return new Howl({
            src: [`./static/media/ogg_folder/pm-default.ogg`],
            autoplay: false,
            loop: false,
            volume: 1,
            onplayerror: (ex) => console.error("newPrivateMessage error!", ex),
        });
    }
};

export const popAlertSound = new Howl({
    src: [`./static/media/notification/pop.mp3`],
    autoplay: false,
    loop: false,
    volume: 1,
});

export const defaultNotificationSettings = [
    {
        type: "new_visitor",
        soundFile: "new-conversation-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "new_conversation",
        soundFile: "new-conversation-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "ticket_sound",
        soundFile: "pm-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "new_message",
        soundFile: "new-message-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "private_message",
        soundFile: "pm-default",
        audioLevel: 100,
        desktopNotification: false,
    },
    {
        type: "new_announcement",
        soundFile: "pm-default",
        audioLevel: 100,
        desktopNotification: false,
    },
];
